import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Container, Text } from '@components';
import { useMatchMedia } from '@utils';
import { breakpoints } from '@config';
import {
  Wrapper,
  Inner,
  VideoWrapper,
  Shadow,
  StyledVideo,
  ContentWrapper,
  Content,
  Icons,
  StyledTitle
} from './styles';

export interface StickVideoProps extends PropsWithChildren {
  id?: string;
  position?: 'left' | 'right';
  poster?: string;
  webm: string;
  mpeg: string;
  shadow: string;
}

const StickVideo: React.FC<StickVideoProps> = (props) => {
  const {
    id,
    position = 'left',
    poster,
    webm,
    mpeg,
    shadow,
    children
  } = props;
  
  const [ height, setHeight ] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const match = useMatchMedia(breakpoints.pc);
  
  const calcContainerHeight: () => void = () => {
    let height = 0;
    
    if (ref.current) {
      height = document.documentElement.clientHeight * 2 - ref.current.offsetHeight;
    }
  
    setHeight(height);
  }
  
  useEffect(() => {
    calcContainerHeight();
  });
  
  useEffect(() => {
    window.addEventListener('resize', calcContainerHeight);
    
    return () => {
      window.removeEventListener('resize', calcContainerHeight);
    }
  }, []);
  
  return (
    <Wrapper id={id}>
      <Container>
        <Inner position={position} style={match ? { height } : {}}>
          <VideoWrapper>
            <Shadow shadow={shadow} />
            <StyledVideo poster={poster} webm={webm} mpeg={mpeg} />
          </VideoWrapper>
          <ContentWrapper position={position}>
            <Content ref={ref}>
              {children}
            </Content>
          </ContentWrapper>
        </Inner>
      </Container>
    </Wrapper>
  );
};

const StickVideoIcons: React.FC<PropsWithChildren> = ({ children }) => (
  <Icons>{children}</Icons>
);

const StickVideoHead: React.FC<PropsWithChildren> = ({ children }) => (
  <StyledTitle as={'h2'} level={'2'}>{children}</StyledTitle>
);

const StickVideoBody: React.FC<PropsWithChildren> = ({ children }) => (
  <Text level={'1'} colorName={'textLittleTransparency'}>{children}</Text>
);

export { StickVideo, StickVideoIcons, StickVideoHead, StickVideoBody };
